<template>
    <div>
        <div class="grid grid-cols-1 2xl:grid-cols-2 gap-20 h-fit">
            <div
                v-for="(item, key) in items"
                :key="key"
                class="bg-white p-12 rounded shadow h-fit"
            >
                <div class="flex items-center gap-16 mb-8">
                    <svg-icon
                        class="w-32 h-32 fill-primary-80"
                        :type="item.icon"
                    />

                    <loading v-if="fetching.summary" size="small" class="min-h-32 my-2"></loading>
                    <strong v-else class="text-heading-2 font-semibold text-black">{{ $numAbbr(item.value) }}</strong>
                </div>

                <strong class="block text-black mt-8">{{ item.title }}</strong>
            </div>
        </div>
    </div>
</template>


<script>
import SvgIcon from '../../components/ui/SvgIcon.vue';
import Loading from '../../components/ui/Loading';
import {mapStores} from "pinia";
import {useDashboardStore} from "../../state/modules/dashboard";

export default {
    components: {Loading, SvgIcon},
    computed: {
        ...mapStores(useDashboardStore),
        fetching() {
            return this.dashboardStore.fetching;
        },
        summary() {
            return this.dashboardStore.summary;
        },
        items() {
            return {
                jobs: {
                    icon: 'format-list-bulleted',
                    title: this.$t('jobs.active_jobs'),
                    value: this.summary.jobs,
                },
                campaigns: {
                    icon: 'campaign',
                    title: this.$t('campaigns.ongoing_campaigns'),
                    value: this.summary.campaigns,
                },
            }
        }
    },
    methods: {},
    mounted() {
    },
};
</script>
